fragment TimestampsFull on Timestamps {
  createdAt
  createdBy
  modifiedAt
  modifiedBy
  deletedAt
  deletedBy
}
